import {CHANGE_LANGUAGE} from "../actions/actions.js";
import {
    languages,
    SELECTED_LANGUAGE
} from '../constants/available_languages';

const selectedLanguage = detectLanguage();

function detectLanguage() {
    let userSelectedLanguage = localStorage.getItem(SELECTED_LANGUAGE);
    if (userSelectedLanguage) {
        return JSON.parse(userSelectedLanguage);
    }

    const userLang = navigator.language || navigator.userLanguage; 
    const shortLang = userLang.split('-')[0];

    const matchedLanguage = languages.find(lang => lang.key === shortLang);
    return matchedLanguage || {
        key: "us",
        lang: "en",
        alt: "United States",
        title: "English (US)"
    };
}

const initialState = {
    selected: selectedLanguage, available: languages
}

/**
 * Language reducer. Reduce state based on action type.
 *
 * @param {object} state the state of the language
 * @param {action} action the action to execute on the state
 */
export function language(state = initialState, action) {
    switch (action.type) {
        case CHANGE_LANGUAGE: {
            return {...state, selected: action.selected};
        }
        default: {
            return state
        }
    }
}